import React, { useMemo } from 'react';

interface Props {
  value: number;
  max: number;
  onValueChange: (newValue) => void;
  skuNumber: string;
}

const QuantitySelector = ({ value, max, onValueChange, skuNumber }: Props) => {
  const optionElements = useMemo(() => {
    const tempOptions = [];
    for (let i = 0; i <= max; i++) {
      tempOptions.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return tempOptions;
  }, [max]);

  const handleChange = (event) => {
    onValueChange(event.target.value);
  };

  return (
    <select
      id={`quantity-selector-${skuNumber}`}
      onChange={handleChange}
      value={value}
      className='quantity-selector form-control'
    >
      {optionElements}
    </select>
  );
};

export default QuantitySelector;
